import React, {useEffect, useRef, useState} from "react";
import {useLocation} from "react-router-dom";
import {Modal} from "react-bootstrap";
import useModalQueue from "./useModalQueue";
import {useSelector} from "../../../shared-services/redux-tiny";
import useClickOutside from "../../shared/useClickOutside";

const FarmyModal = (
  {
    children,
    onClose = () => {},
    hide,
    modalName = "",
    animation = true,
    closeOnEsc = true,
    closeOnClickOutside = true,
    beforeOpen = null,
    closeOnLocationChange = false,
    ...additionalProps
  }
) => {
  const {closeModal} = useModalQueue(modalName);
  const {currentModal} = useSelector(state => state.topLayer);
  const location = useLocation();
  const [show, setShow] = useState(false);

  const modalRef = useRef();

  const isCurrentModal = () => currentModal && currentModal?.name === modalName;

  // "closeOnClickOutside" prop ensures that the modal will close when clicking outside.
  useClickOutside(
    ".modal-content",
    () => closeOnClickOutside && show && close(),
    [hide, currentModal?.name, closeOnClickOutside, show]);

  const close = () => {
    isCurrentModal() && closeModal();
  };

  const onEscKeyPressed = () => {
    closeOnEsc && close();
  };

  useEffect(() => {
    if (closeOnLocationChange) close();
  }, [location]);

  useEffect(() => {
    const shouldShow = isCurrentModal();

    if (beforeOpen && shouldShow) {
      beforeOpen(currentModal)
        .then(r => {
          setShow(shouldShow);
        })
        .catch(e => {
          console.error(e);
          setShow(false);
        });
    } else {
      setShow(shouldShow);
    }
  }, [currentModal?.name]);

  const parentProps = {
    animation,
    onHide: () => {},
    onExit: onClose,
    ...additionalProps
  };

  return (
    <Modal
      show={show}
      onEscapeKeyDown={onEscKeyPressed}
      {...parentProps}
      ref={modalRef}
    >
      {children}
    </Modal>
  );
};

export default FarmyModal;
